import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms'
import { DataService } from '../../shared/data.service';
import { SearchService } from '../search.service';
import { SearchParams } from '../models/searchParams.model';
import { BrowserStorageService } from 'src/app/shared/browser-storage.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-search-form',
  templateUrl: './search-form.component.html',
  styleUrls: ['./search-form.component.css']
})
export class SearchFormComponent implements OnInit, OnDestroy {
  @ViewChild('f', { static: false }) searchForm: NgForm;
  searchField: string = "Company";
  searchTerm: string = "";
  searchField2: string = "City";
  searchTerm2: string = "";
  radius: number = 50;
  radiusTimeout: any;
  isRadiusSearch: boolean = false;
  $: any;

  constructor(private dataService: DataService, private searchService: SearchService, private storage: BrowserStorageService) { }

  ngOnInit() {
    this.searchService.searchParamsChanged.subscribe((params: SearchParams) => {
      this.searchField = params.Field;
      this.searchTerm = params.Term;
      this.searchTerm2 = params.Term2;
      this.searchField2 = params.Field2;
      this.isRadiusSearch = params.IsRadiusSearch;
      this.storage.savePermanent("SearchField", params.Field);
      this.storage.savePermanent("SearchField2", params.Field2);
      this.storage.savePermanent("RadiusValue", this.radius);
    });
    var field = this.storage.getPermanentValue("SearchField");
    if (field.length > 0)
      this.searchField = field;
    var field2 = this.storage.getPermanentValue("SearchField2");
    if (field2.length > 0)
      this.searchField2 = field2;
    var storedRadius = this.storage.getPermanentValue("RadiusValue");
    if (storedRadius == "")
      storedRadius = "50";
    this.radius = +storedRadius;
  }
  ngOnDestroy() {
    this.searchService.searchParamsChanged.unsubscribe();
  }
  onSubmit() {
    this.dataService.getSearchResults(this.searchForm.value.terms, this.searchForm.value.field, this.searchForm.value.terms2, this.searchForm.value.field2, this.radius);
    this.storage.savePermanent("SearchField", this.searchForm.value.field);
    this.storage.savePermanent("SearchField2", this.searchForm.value.field2);
    this.storage.savePermanent("RadiusValue", this.radius);
  }
  onRadiusChange(event: any){
    if (this.radiusTimeout !== undefined) {
      clearTimeout(this.radiusTimeout);
    }
    this.radiusTimeout = setTimeout(this.onSubmit.bind(this), 1000);
  }
  onBlur(target: any) {
  }
}
